
import { defineComponent } from "vue";
import {translate} from '@elements/translations';

export default defineComponent({
    name: "FormLabel",
    props: {
        className: {
            default: 'form-label',
            type: String
        },
        id: {
            default: null,
            required: true,
            type: String
        },
        required: {
            type: Boolean,
            default: false
        },
        label: {
            type: String,
            required: true,
        },
    },
    setup() {
        return {
            translate
        };
    }
});
